import { OnInit, OnDestroy, Inject, Optional } from '@angular/core';
import { Component } from '@angular/core';
import { IContextService, DomainContext, PershingTranslationService } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'digital-advice-login-section',
    templateUrl: './digital-advice-login-section.component.html'
})
export class DigitalAdviceLoginSection implements OnInit, OnDestroy {
    inputValue: string = '';
    subs: Subscription;
    digitalAdviceLink: string;
    internalAdvice: boolean = false;
    loginDaTitle: string;
    loginDaExploreLabel: string;
    loginDaText: string;
    domain: string = '';
    ibd: string;
    hideLoginDa: boolean = false;
    appSettings: any;
    target: string;
    constructor(
        private contextService: IContextService,
        private translationService: PershingTranslationService,
        private nxiRestService: NxiRestService,
        @Optional() @Inject('AppSettings') appSettings: any
    ) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
        this.appSettings = appSettings;
        this.ibd = this.appSettings.ibdConfigMap.IBD;
        if (this.ibd === '5L9') {
            this.hideLoginDa = true;
        }
    }
    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.getDALoginParams();
        });
    }
    ngOnDestroy(): void {
        if (this.subs) {
            this.subs.unsubscribe();
        }
    }
    getDALoginParams() {
        this.nxiRestService.getNxiRestUrlResponse(this.nxiRestService.serviceUrl + '/darestService/vendors').subscribe(
            resp => {
                console.log('Retrieved common REST DA Overview widgets param : ', resp.response);
                if (resp.response) {
                    for (let i = 0; i < resp.response.vendors.length; i++) {
                        this.internalAdvice = resp.response.vendors[i].internalAdvice;
                        this.loginDaTitle = resp.response.vendors[i].digitalAdviceParams.loginDaTitle;
                        this.hideLoginDa = resp.response.vendors[i].digitalAdviceParams.hideDaPrelogin;
                        this.loginDaExploreLabel = resp.response.vendors[i].digitalAdviceParams.loginDaExploreLabel;
                        if (this.internalAdvice) {
                            this.digitalAdviceLink = '/nxi/' + resp.response.vendors[i].preloginUrl;
                            this.target = '_self';
                        } else if (resp.response.vendors[i].digitalAdviceParams.loginDaExploreLink !== null) {
                            this.digitalAdviceLink = resp.response.vendors[i].digitalAdviceParams.loginDaExploreLink;
                            this.target = '_blank';
                        } else {
                            this.digitalAdviceLink = '/nxi/' + resp.response.vendors[i].preloginUrl + '?reason=netx&domain=' + this.domain + '&pershing_ibd=' + this.ibd;
                            this.target = '_blank';
                        }
                        this.loginDaText = resp.response.vendors[i].digitalAdviceParams.loginDaText;
                        
                    }
                }
            }
        );
    }

}
